let code = 'cosigestao';
let codeAPI = 'cosi';
let codeCENTRAL = 'cosicentral';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
    codeCENTRAL: `${codeCENTRAL}`,
};